export const getVerticalFooterData = () => [];
export const setVerticalFooterData = () => { };
